import {userPrefs} from '@netx/core-user/collections/singletons/userPreferences';

export const setPreference = (key: string, value: any) =>
	userPrefs.setUserPreference(key, value);

export default setPreference;
